module.exports = __webpack_public_path__ + "static/img/121_TO8_1661.14ce735.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/121_TO8_1661.jpg
// module id = KF6w
// module chunks = 0